package io.github.jpuf.portfolio.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import io.github.jpuf.portfolio.BodyTextStylePadded
import io.github.jpuf.portfolio.GalleryContainerStyle
import io.github.jpuf.portfolio.HeadlineUnderlinedTextStyle
import io.github.jpuf.portfolio.components.layouts.PageLayout
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.pt
import org.jetbrains.compose.web.dom.Div

val PhotographyPageContentStyle = CssStyle {
    base { Modifier.fillMaxSize().padding(leftRight = 2.cssRem, top = 0.cssRem) }
    Breakpoint.MD { Modifier.maxWidth(80.cssRem) }
}

@Page
@Composable
fun PhotographyPage() {
    PageLayout("Photography", PhotographyPageContentStyle) {
        Column(
            modifier = GalleryContainerStyle.toModifier().gap(0.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Div(HeadlineUnderlinedTextStyle.toAttrs()) {
                SpanText("Photography")
            }
            Div(BodyTextStylePadded.toAttrs()) {
                SpanText(
                    "I've tried my hand at photography ever since my uncle gave me his old Minolta. Here are some of the results!"
                )
            }

            Div {
                Gallery()
            }
        }
    }
}

@Composable
private fun PhotoGridCell(
    imagePath: String,
    row: Int,
    column: Int,
    width: Int? = null,
    height: Int? = null
) {
    Div(
        Modifier
            .gridItem(row, column, width, height)
            .toAttrs()
    ) {
        Image(imagePath, modifier = Modifier.fillMaxWidth())
    }
}

@Composable
fun Gallery() {
    Div(
        Modifier
            .grid {
                rows { size(1.fr); size(1.fr) }
                columns { repeat(3) { size(1.fr) } }
            }
            .gap(8.pt)
            .toAttrs()
    ) {
        PhotoGridCell(
            imagePath = "/photography/bales.jpg",
            row = 1,
            column = 1,
            width = 3
        )

        Div(
            Modifier
                .padding(topBottom = 2.cssRem)
                .gridItem(2, 1, 3, null)
                .toAttrs()
        ) {
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                Image("/photography/fog1.jpg", modifier = Modifier.fillMaxWidth(48.percent))
                Image("/photography/fog2.jpg", modifier = Modifier.fillMaxWidth(48.percent))
            }
        }

        PhotoGridCell(
            imagePath = "/photography/jarvi_yo.jpg",
            row = 3,
            column = 1
        )
        PhotoGridCell(
            imagePath = "/photography/ginnel.jpg",
            row = 3,
            column = 2
        )
        PhotoGridCell(
            imagePath = "/photography/manchester_cliche.jpg",
            row = 3,
            column = 3
        )


        PhotoGridCell(
            imagePath = "/photography/cow.jpg",
            row = 4,
            column = 1
        )
        PhotoGridCell(
            imagePath = "/photography/silhouette.jpg",
            row = 4,
            column = 2
        )
        PhotoGridCell(
            imagePath = "/photography/muddy_horse.jpg",
            row = 4,
            column = 3
        )

        Div(
            Modifier
                .padding(topBottom = 2.cssRem, leftRight = 2.cssRem)
                .gridItem(5, 1, 3, null)
                .toAttrs()
        ) {
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                Image("/photography/jog.jpg", modifier = Modifier.fillMaxWidth(48.percent))
                Image("/photography/lakes.jpg", modifier = Modifier.fillMaxWidth(48.percent))
            }
        }

        Div(
            Modifier
                .padding(leftRight = 2.cssRem).padding(bottom = 4.cssRem)
                .gridItem(6, 1, 3, null)
                .toAttrs()
        ) {
            Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                Image("/photography/marmalade.jpg", modifier = Modifier.fillMaxWidth(48.percent))
            }
        }
    }
}